import React from 'react';

import { FontAwesomeIcon } from '@appcharge/shared-ui';

import Button from 'components/Button/Button';

interface IBlockMenuItemDetachButtonProps {
  blockType: string;
  onDetach: () => void;
}

export const BlockMenuItemDetachButton: React.FC<
  IBlockMenuItemDetachButtonProps
> = ({ blockType, onDetach }) => {
  const handleClick = (event: React.MouseEvent): void => {
    event.preventDefault();
    event.stopPropagation();
    onDetach();
  };

  return (
    <Button
      type="button"
      variant="ghost"
      onClick={handleClick}
      className="p-1 h-auto w-auto hover:bg-gray-100 rounded transition-colors opacity-0 group-hover/collapsible:opacity-100"
      title="Detach block"
      data-testid={`TemplatesStudio-BlockVisibility-${blockType}`}
    >
      <FontAwesomeIcon
        icon="fa-regular fa-link-broken"
        className="text-sm text-base-mutedForeground hover:text-gray-700"
      />
    </Button>
  );
};
